import React from 'react'
import logo from '../../img/logo.png'
import { BsTwitter, BsYoutube } from "react-icons/bs";
import { IoIosSend, } from "react-icons/io";
import { FaFacebookF, } from "react-icons/fa";
import { TbWorld, } from "react-icons/tb";
import { Link } from "react-router-dom";
const socialData = [
    {
        id: 0,
        href: 'https://google.com',
        icon: <TbWorld />,
    },
    {
        id: 1,
        href: 'https://twitter.com',
        icon: <BsTwitter />,
    },
    {
        id: 2,
        href: 'https://cloudpet.io',
        icon: <IoIosSend />,
    },
    {
        id: 3,
        href: 'https://facebook.com',
        icon: <FaFacebookF />,
    },
    {
        id: 4,
        href: 'https://youtube.com',
        icon: <BsYoutube />,
    },
]

const Footer = () => {
    return (
        <footer className='footer-area pb-5'>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 text-center text-lg-start">
                        <Link to="/"><img src={logo} height={70} alt="logo" /></Link>
                    </div>
                    <div className="col-lg-6 align-self-center mt-4 mt-lg-0">
                        <ul className="social d-flex justify-content-center justify-content-lg-end gap-2">
                            {socialData.map((item) => (
                                <li key={item.id}><a target="_blank" rel='noreferrer' href={item.href}>{item.icon}</a></li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="row pt-4">
                    <div className="col-lg-5">
                        <p className='text-white footer-d'>
                            ACNRich Launchpad enables new projects to raise funds through token sales by allowing investors to
                            participate in their early stages before they are made public. The AVNPAD platform integrates and
                            incorporates AVN into the token sale process.
                            AVNPAD is developed as a solution for fair participation on ID's,
                        </p>
                    </div>
                    <div className="col-lg-6 ms-lg-auto mt-4 mt-lg-0">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="footer-widget">
                                    <div className="title text-white fs-2 fw-light mb-4">General</div>
                                    <ul>
                                        <li><a href="https://staking.avnpad.io/">Staking</a></li>
                                        <li><a href="https://farm.avnrichdefi.com/">Farming</a></li>
                                        <li><a href="#">About IDO Distribution</a></li>
                                        <li><a href="https://drive.google.com/file/d/1R2sJWvX9wFA4qIQcuqkruZCglge_UnA6/view?usp=drivesdk">Privacy Policy</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="footer-widget pt-5 pt-md-0 pt-lg-0">
                                    <div className="title text-white fs-2 fw-light mb-4">Help</div>
                                    <ul>
                                        <li><a href="https://avnrich.medium.com/avnpad-716a1c7e19e">How to participate in IDO?</a></li>
                                        <li><a href="https://docs.google.com/forms/d/e/1FAIpQLSf3eKvAqiiNi4CCDcVi5-uMavPnjjgWZVDOfdK9HBLrLd0xpg/viewform">Apply for IDO</a></li>
                                        <li><a href="https://avnpad.io/faq.pdf">FAQ's</a></li>
                                        <li><a href="https://drive.google.com/file/d/1mlqGSKyrNsQ4gyGQ126T4PEer4squpDq/view?usp=drivesdk">Terms & Conditions</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
